import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface WorkEventItem {
  event_type: string;
  payload: Record<string, string>;
  created_at: string;
}

export interface PipelineRunItem {
  run_id: string;
  pipeline_name: string;
  issue_id: string | null;
  status: string;
  current_phase: string;
  phase_count: number;
  created_at: string;
  updated_at: string;
}

export interface WorkState {
  active_epic: string | null;
  active_story: string | null;
  event_count: number;
  stories_closed: number;
  pipeline_runs: PipelineRunItem[];
  recent_events: WorkEventItem[];
  total: number;
}

export interface WorkStateFilters {
  since?: string;
  limit?: number;
}

export function useWorkState(
  projectSlug: string | null,
  filters: WorkStateFilters = {},
) {
  const query = useQuery({
    queryKey: queryKeys.workState.detail(projectSlug ?? "", filters),
    queryFn: () => {
      const params = new URLSearchParams();
      if (filters.since) params.set("since", filters.since);
      if (filters.limit) params.set("limit", String(filters.limit));
      return api<WorkState>(
        `/api/v2/projects/${projectSlug}/memory/work?${params.toString()}`,
      );
    },
    enabled: projectSlug !== null,
  });

  return {
    state: query.data ?? null,
    loading: query.isLoading,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : "Failed to load work data"
      : null,
  };
}
